@if (!!actions) {
  <mat-toolbar
    class="top-bar"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    [class.settings]="isSettingsSection()"
    [class.di-none]="
      actions?.buttons && !actions.buttons?.length && !breadcrumbs.length
    "
  >
    <div
      class="toolbar-container"
      fxLayout="column"
      fxLayoutAlign="space-between"
    >
      <div class="actions-container" fxLayoutAlign="space-between center">
        <div class="breadcrumbs" fxLayoutAlign="space-between center">
          @for (crumb of breadcrumbs; track crumb; let index = $index) {
            <div class="breadcrumb-item">
              <a
                [routerLink]="crumb.url"
                [class.current]="index === breadcrumbs.length - 1"
              >
                {{ crumb.key | translate: crumb.args }}
              </a>
              @if (index < breadcrumbs.length - 1) {
                <mat-icon>chevron_right</mat-icon>
              }
            </div>
          }
        </div>
        <div class="cta" fxLayout="row" #actionButtons>
          @if (actions?.menu && !hideMenuButton) {
            <button
              mat-stroked-button
              [color]="actions?.menu?.color || 'darkblue'"
              [ngClass]="actions?.menu?.class || ['no-border']"
              [matMenuTriggerFor]="menu"
            >
              <mat-icon class="size-m" aria-hidden="true">{{
                actions?.menu?.icon
              }}</mat-icon>
              {{ actions?.menu?.label || '' | translate }}
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
              @for (button of actions?.menu?.buttons; track button) {
                @if (button.name !== 'guidedCourseCreation' || aiEnabled) {
                  <a mat-menu-item (click)="runAction(button.action)">
                    @if (button?.icon) {
                      <mat-icon aria-hidden="true">{{ button.icon }}</mat-icon>
                    }
                    @if (button?.iconSvg) {
                      <mat-icon
                        aria-hidden="true"
                        svgIcon="{{ button?.iconSvg }}"
                      ></mat-icon>
                    }
                    <span class="menu-item-label">
                      {{ button.label | translate }}
                    </span>
                  </a>
                }
              }
            </mat-menu>
          }
          @for (button of actions?.buttons; track button) {
            @if (
              button?.name === 'filters' &&
              (actions.buttons.length > 1 || !!actions.menu)
            ) {
              <div class="filter-btn-separator"></div>
            }
            <div fxLayout="column">
              @if (!hideAction(button)) {
                <button
                  mat-stroked-button
                  [color]="button.color"
                  [ngClass]="button?.class || ['action-button']"
                  [disabled]="disableAction(button.name)"
                  [routerLink]="getButtonRouterLink(button)"
                  (click)="runAction(button.action)"
                >
                  <span class="mat-button-wrapper">
                    @if (button?.icon) {
                      <mat-icon class="size-m" aria-hidden="true">{{
                        button.icon
                      }}</mat-icon>
                    }
                    @if (button?.iconSvg) {
                      <mat-icon
                        aria-hidden="true"
                        class="svg-icon size-m"
                        svgIcon="{{ button?.iconSvg }}"
                      ></mat-icon>
                    }
                    <span>{{ button?.label || '' | translate }}</span>
                    @if (
                      button?.name === 'filters' &&
                      actions?.filters &&
                      filterCounter > 0
                    ) {
                      <div
                        fxLayout="row"
                        fxLayoutAlign="flex-start center"
                        fxLayoutGap="8px"
                        class="filters-counter"
                      >
                        <div>{{ filterCounter }}</div>
                      </div>
                    }
                    @if (button?.name === 'filters' && expandFilters) {
                      <mat-icon class="size-m">expand_less</mat-icon>
                    }
                    @if (button?.name === 'filters' && !expandFilters) {
                      <mat-icon class="size-m">expand_more</mat-icon>
                    }
                  </span>
                </button>
              }
              @if (button?.name === 'filters' && expandFilters) {
                <div class="filter-expanded"></div>
              }
            </div>
          }
        </div>
      </div>
      <app-toolbar-filters
        [filters]="$safeNavigationMigration(actions?.filters)"
        [storeId]="$safeNavigationMigration(actions?.storeId)"
        [expandFilters]="expandFilters"
        [enableLoginUsername]="enableLoginUsername"
        (doFilters)="doApplyFilters($event)"
        (resetFilters)="doResetFilters($event)"
        (filterCounter)="onFilterCounter($event)"
        [class.d-none]="!actions?.filters?.length"
      >
      </app-toolbar-filters>
    </div>
  </mat-toolbar>
}
